<div class="backModal enCalendar">
  <div class="close closeModal">
    <a title="cerrar" (click)="close()"
      ><span class="cross"></span><span class="sr-only">cerrar</span></a
    >
  </div>
  <div class="aviso">
    <div class="tituloModal">{{ 'PREGUNTA_CERRAR_CAJA' | translateV2 }}</div>
    <div class="gestionTurno">
      <!-- <a class="GestionarButton" title="SALIR SIN CERRAR TURNO" (click)="salirSinCerrarTurno()">SALIR SIN CERRAR TURNO</a> -->
      <a
        class="GestionarButton"
        title="{{ 'CAMBIAR_USUARIO' | translateV2 }}"
        (click)="cambiarUsuario()"
      >
        {{ 'CAMBIAR_USUARIO' | translateV2 }}
      </a>
      <a
        *ngIf="tieneTurnoAbierto()"
        class="GestionarButton"
        title="{{ 'CERRAR_CAJA' | translateV2 }}"
        (click)="cerrarCaja()"
      >
        {{ 'CERRAR_CAJA' | translateV2 }}
      </a>
      <a
        *ngIf="tienePermiso('CierreSalirSinCerrar')"
        class="GestionarButton"
        title="{{ 'SALIR_SIN_CERRAR_CAJA' | translateV2 }}"
        (click)="salirSinCerrarTurno()"
      >
        {{ 'SALIR_SIN_CERRAR_CAJA' | translateV2 }}
      </a>
    </div>
  </div>
</div>
